export interface LoadFetchDO {
  isLoading?: boolean;
  fetchingData?: boolean;
  type?: string;
  response?: "SUCCESS" | "ERROR";
}

export interface GenericStateMeta {
  isLoading: boolean;
  isSuccess?: boolean;
  error: null | any;
  status: "idle" | "inProcess" | "error" | "success";
}

export const defaultGenericMeta: GenericStateMeta = {
  isLoading: false,
  error: null,
  status: "idle",
};

export interface GenericActionError {
  status?: number;
  statusMessage?: string;
}

export interface ServiceMeta {
  pageNum?: number;
  totalCount?: number;
  sortColumn?: number;
  sortDir?: number;
}

export interface FilterProps {
  sortColumn?: number;
  sortDir?: number;
  transactionYear?: string;
  minDate?: string | null;
  maxDate?: string | null;
  searchKeyword?: string;
  dueDate?: number;
  pastDue?: number;
  autoPay?: number;
  pageNumber?: number;
  pageSize?: number;
  dueIn5days?: number;
  confirmationNumber?: string;
  paymentMethodType?: number;
  status?: number;
  accountInformationId?: number;
  accountNumber?: string;
  excludeErrorStatus?: boolean;
}
